'use client';

import { Carousel } from '@mantine/carousel';
import { Box, Card, Group, Stack } from '@mantine/core';
import { ActionTab } from '@/components/Shares/ActionTab';
import { CardTitle } from '@/components/Shares/CardTitle';
import { WinUser } from './WinUser';
import { users } from './users';
const times = ['24HR', '7D', '1M', '3M', 'ALL'];
export const BigWin: React.FC = () => {
  return <Card bg="var(--navbar-bg-color)" radius="sm" mt="sm">
      <Stack>
        <Group justify="space-between" wrap="nowrap" gap={0}>
          <CardTitle firstText="Latest" secondText="Big wins" isSecondGradient colorFrom="#DBFE02" colorTo="#44FF66" iconUrl="/assets/title-icons/1.png" mt={6} />
          <ActionTab items={times} activeIndex={0} miw={100} />
        </Group>

        <Box style={{
        maskImage: 'linear-gradient(275deg, rgba(255,255,255,0) 0%, rgba(34,38,43,1) 10%)'
      }}>
          <Carousel align="start" h="100%" slideSize="4%" slideGap="md" loop withControls={false}>
            {users.map(user => <Carousel.Slide key={user.url}>
                <WinUser url={user.url} username={user.username} price={user.price} />
              </Carousel.Slide>)}
          </Carousel>
        </Box>
      </Stack>
    </Card>;
};